/**
 * First off, load lodash for all sorts of things
 */
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');

/**
 * Set up jQuery to always embed laravel csfr Token into Ajax requests
 */
window.$.ajaxSetup({headers: {
    'X-CSRF-TOKEN': Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
}});

/**
 * Alpine.js
 *
 * Alpine.js offers you the reactive and declarative nature of big frameworks like Vue or React at a much lower cost
 * https://github.com/alpinejs/alpine
 *
 * Until we resolve the issue with IE 11 and transpiling for non-modular support, alpine will be included separately
 * import 'alpinejs'
 */

/**
 * Sass-powered version of Bootstrap 3, ready to drop right into your Sass powered applications.
 *
 * https://getbootstrap.com/docs/3.3/css/
 */
require('bootstrap-sass');

/**
 * Bootstrap all betta Angular App Modules
 */
require('./app/bootstrap');

/**
 * Bootstrap all betta functionality
 */
require('./betta');

/**
 * Package: Betta Taggable
 * Bootstrap Betta tagging service and controller
 */
require('./taggable');

/**
 * Package: Betta Dashboard
 * Bootstrapdashboard services and controllers
 */
require('./dashboard');

/**
 * A simple datepicker component for Twitter Bootstrap.
 *
 * https://bootstrap-datepicker.readthedocs.io/en/stable/
 */
require('bootstrap-datepicker');

/**
 * A simple timepicker component for Twitter Bootstrap.
 *
 * https://github.com/jdewit/bootstrap-timepicker
 */
require('bootstrap-timepicker');

/**
 * Select2
 * Select2 is a jQuery-based replacement for select boxes.
 * It supports searching, remote data sets, and pagination of results.
 *
 * https://select2.org/
 */
require('select2');

/**
 * list.js
 * The perfect library for adding search, sort, filters and flexibility to tables, lists and various HTML elements.
 * Built to be invisible and work on existing HTML.
 *
 * https://listjs.com
 */
window.List = require('list.js');

/**
 * Moment.js
 * A lightweight JavaScript date library for parsing, validating, manipulating, and formatting dates.
 *
 * http://momentjs.com/
 */
window.moment = require('moment');

/**
 * EasyTimer.js
 * Easy to use Timer/Chronometer/Countdown library compatible with AMD and NodeJS
 *
 * http://albert-gonzalez.github.io/easytimer.js/
 */
window.easytimer = require('easytimer.js')

/**
 * Toastr
 * toastr is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended.
 *
 * https://github.com/CodeSeven/toastr
 */
window.toastr = require('toastr');

/**
 * TinyMCE
 * TinyMCE is an open source software providing for the HTML inline editor.
 *
 * https://www.tinymce.com/
 */
import tinymce from 'tinymce/tinymce';

/**
 * TinyMCE Plugins
 *
 * @see  https://www.tinymce.com/
 */
import 'tinymce/skins/lightgray/skin.min.css';
import 'tinymce/plugins/paste/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/autoresize/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/themes/modern/theme'

/**
 * Pull the NPM DataTables package into the JS codebase
 *
 * Older version of code:
 *     window.dt = require('datatables.net');
 *     require('datatables.net-bs');
 *
 * Update: Old browser support is shaky for the Webpack;
 * Instead of require (which will apparently _lodash), we need to import as is
 */
import 'datatables.net';

import dt from 'datatables.net-bs';

/**
 * Pull Highcharts into the code as a package
 */
var Highcharts = window.Highcharts = require('highcharts');

/**
 * Add Modules to highcharts
 */
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.

    window.Vue = require('vue');
    require('vue-resource');
 */

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.

    Vue.http.interceptors.push((request, next) => {
        request.headers['X-CSRF-TOKEN'] = Laravel.csrfToken;
        next();
    });
 */

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
*/
import Echo from "laravel-echo"

try {
    // Instantiate Pusher
    window.Pusher = require('pusher-js');
    // Fins the key
    let pusherKey = document.head.querySelector('meta[name="pusher-key"]');
    // Is we have the key
    if (pusherKey) {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: pusherKey.content,
            cluster: 'us2',
            forceTLS: true
        });
    } else {
        console.error('Pusher Key not found. Check for Pusher Key');
    }
} catch (error) {
    console.error(error);
}
